module.exports = __webpack_public_path__ + "fb7f202e282716f2388cd41f2fb0849e.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/quality-control.png
// module id = 2061
// module chunks = 2